import {
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

export const XhrRequestInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    if (!request.headers.get('X-Requested-With')) {
        request = request.clone({
            headers: request.headers.append(
                'X-Requested-With',
                'XMLHttpRequest',
            ),
        });
    }
    return next(request);
};
